module.exports = __webpack_public_path__ + "system/static/img/icon_right_swiper_delete.0eb4d43c.png";